var _radialGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _radialGradient2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "K5rKLmYY5bGzCTT1uDwOPa",
    cx: -2.043,
    cy: 1356.043,
    r: 53.845,
    gradientTransform: "translate(0 -1354)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K5rKLmYY5bGzCTT1uDwOPa)",
    d: "M43.125,9H4.875C3.287,9,2,10.287,2,11.875v24.25C2,37.713,3.287,39,4.875,39h38.25 C44.713,39,46,37.713,46,36.125v-24.25C46,10.287,44.713,9,43.125,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M7.949,25.515c-0.378,0.341-0.869,0.49-1.646,0.49H5.981v-4.077h0.323 c0.777,0,1.249,0.139,1.646,0.499c0.416,0.37,0.666,0.944,0.666,1.535C8.615,24.553,8.365,25.144,7.949,25.515z M6.544,20.883 H4.779v6.165h1.756c0.934,0,1.608-0.22,2.2-0.712c0.703-0.582,1.119-1.459,1.119-2.367C9.854,22.151,8.495,20.883,6.544,20.883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M10.407,27.048h1.203v-6.165h-1.203V27.048z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M14.55,23.249c-0.722-0.267-0.934-0.443-0.934-0.776 c0-0.388,0.378-0.683,0.896-0.683c0.36,0,0.656,0.148,0.97,0.499l0.629-0.824c-0.517-0.452-1.136-0.684-1.812-0.684 c-1.091,0-1.923,0.758-1.923,1.767c0,0.849,0.387,1.284,1.517,1.691c0.471,0.166,0.71,0.277,0.831,0.351 c0.24,0.157,0.361,0.379,0.361,0.638c0,0.5-0.397,0.87-0.934,0.87c-0.574,0-1.036-0.287-1.312-0.822l-0.777,0.748 c0.554,0.813,1.219,1.174,2.134,1.174c1.25,0,2.126-0.831,2.126-2.024C16.324,24.193,15.918,23.749,14.55,23.249"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M16.703,23.97c0,1.812,1.423,3.217,3.254,3.217c0.518,0,0.961-0.102,1.508-0.359 v-1.416c-0.481,0.481-0.907,0.675-1.452,0.675c-1.211,0-2.071-0.878-2.071-2.127c0-1.184,0.887-2.117,2.015-2.117 c0.574,0,1.008,0.205,1.508,0.694v-1.415c-0.528-0.268-0.962-0.379-1.479-0.379C18.164,20.744,16.703,22.177,16.703,23.97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M31,25.024l-1.644-4.141h-1.314l2.616,6.323h0.647l2.663-6.323h-1.304L31,25.024"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M34.513,27.048h3.41v-1.044h-2.209V24.34h2.127v-1.044h-2.127v-1.368h2.209v-1.045 h-3.41V27.048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4e52",
    d: "M40.272,23.722h-0.351v-1.867h0.37c0.749,0,1.156,0.314,1.156,0.914 C41.447,23.388,41.04,23.722,40.272,23.722z M42.684,22.703c0-1.154-0.795-1.82-2.182-1.82h-1.783v6.165h1.201v-2.477h0.157 l1.665,2.477h1.479l-1.941-2.597C42.186,24.267,42.684,23.647,42.684,22.703"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.858,23.988c0,0,0,0,0-0.002c0-1.81,1.468-3.279,3.279-3.279c1.812,0,3.281,1.469,3.281,3.279 c0,0.002,0,0.002,0,0.002c0,1.81-1.469,3.279-3.281,3.279C23.326,27.267,21.858,25.799,21.858,23.988"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "K5rKLmYY5bGzCTT1uDwOPb",
    cx: 27.473,
    cy: 26.521,
    r: 8.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5be00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#c4431f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#751b0b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.143,
    cy: 24,
    r: 3.299,
    fill: "url(#K5rKLmYY5bGzCTT1uDwOPb)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.a9ee9976f087d5f6db41f6b155b7fdcc.svg";
export { ForwardRef as ReactComponent };